import { useState } from "react";
import { useTranslation } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";

import Button from "ab-form-button";
import BlogSmall from "ab-blog-small";

import DynamicContent from "../../components/DynamicContent";
import { getPage, getPosts } from "ab-api-queries";

const Home = ({ content = [], posts = [], pageInfo, moduloCross }) => {
  const [nextPosts, setNextProps] = useState({ nodes: posts, pageInfo });
  console.log("Blogs", content, posts, pageInfo, nextPosts);
  const { i18n } = useTranslation("common");
  return (
    <>
      {content?.map((itm, index) => (
        <DynamicContent
          {...itm}
          moduloCross={moduloCross}
          key={`${itm.fieldGroupName}-${index}`}
          i18n={i18n}
        />
      ))}
      {nextPosts?.nodes?.map((itm, index) => {
        return <BlogSmall rtl={index % 2 == 1} post={itm} i18n={i18n} />;
      })}
      <div
        style={{
          backgroundColor: "#f9f6ef",
          flexDirection: "row",
          justifyContent: "space-between",
          padding: "0 Max(113px, calc((100% - 1440px) / 2 + 113px))",
        }}
      >
        {nextPosts?.pageInfo?.hasPreviousPage ? (
          <Button
            onClick={() =>
              getPosts({
                before: nextPosts?.pageInfo?.startCursor,
                last: 10,
                where: {
                  language: i18n.language.toUpperCase(),
                },
              }).then((res) => {
                setNextProps(res.posts);
              })
            }
          >
            Anterior Página
          </Button>
        ) : (
          <div />
        )}
        {nextPosts?.pageInfo?.hasNextPage ? (
          <Button
            onClick={() => {
              getPosts({
                after: nextPosts?.pageInfo?.endCursor,
                first: 10,
                where: {
                  language: i18n.language.toUpperCase(),
                },
              }).then((res) => {
                // console.log("setNextProps", res);
                setNextProps(res.posts);
              });
            }}
          >
            Siguiente Página
          </Button>
        ) : (
          <div />
        )}
      </div>
      <DynamicContent
        fieldGroupName={"Page_Contenidoflexible_Modulos_Disfrute"}
        moduloCross={moduloCross}
        i18n={i18n}
      />
    </>
  );
};

export async function getStaticProps({ locale }) {
  const data = await getPage(`blog`);
  const postData = await getPosts({
    first: 10,
    where: {
      language: "ES",
    },
  });
  const translations = await serverSideTranslations(locale, ["common"]);
  return {
    props: {
      seo: data?.nodeByUri?.seo || {},
      content: data?.nodeByUri?.contenidoFlexible?.modulos || [],
      moduloCross: data?.modulosCross,
      footer: data?.headerFooter?.footer,
      menu: data?.headerFooter?.menu,
      translations: data?.nodeByUri?.translations,
      language: data?.nodeByUri?.language,
      posts: postData?.posts?.nodes || [],
      pageInfo: postData?.posts?.pageInfo || null,
      ...translations,
    }, // will be passed to the page component as props
    notFound:
      !data?.nodeByUri?.contenidoFlexible?.modulos.length > 0 ||
      locale !== "es",
    revalidate: process.env.REVALIDATE ? parseInt(process.env.REVALIDATE, 10) : 1800,
  };
}

export default Home;
